import React from 'react';
import {Modal} from 'react-bootstrap';
import {personFullName} from '../../../../services/Api/index';


const DeleteEmittedCertificateModal = (props)=>{

    const { emittedCertificate, onHide, onConfirm }= props;

    const person = props.person;

    return (
        <Modal
            show={true}
            onHide={onHide}>


            <Modal.Header closeButton>
                <Modal.Title>Eliminar Constancia a miembro</Modal.Title>
            </Modal.Header>

            <Modal.Body >

                <p>¿Estás seguro que deseas eliminar esta Constancia
                    a <strong>{personFullName(person)}</strong> ?
                </p>
                <p>Esta acción no puede deshacerse.</p>

            </Modal.Body>

            <Modal.Footer>
                <button onClick={ onHide } className='btn btn-primary pull-left'>Cancelar</button>
                <button className='btn btn-danger' onClick={ ()=>onConfirm( emittedCertificate ) }>Eliminar</button>
            </Modal.Footer>


        </Modal>
    );
};

export default DeleteEmittedCertificateModal;


// WEBPACK FOOTER //
// ./src/App/scenes/AppFrame/components/DeleteEmittedCertificateModal/index.jsx